module.exports = __webpack_public_path__ + "img/GAME_BUTTERFLY1.209cebf8.jpg";